<template>
  <div class="page-container">
    <main class="main-content">
      <div class="page-inner-box">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
          <el-breadcrumb-item to="/exam">考试</el-breadcrumb-item>
          <el-breadcrumb-item>考试计划</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="detail-card" v-loading="loading">
          <template v-if="content">
            <h1 class="title">{{ content.contentTitle }}</h1>
            <div class="meta">
              <span class="time">发布时间：{{ content.createTime }}</span>
              <span class="views" v-if="content.viewCount">阅读：{{ content.viewCount }}</span>
            </div>
            <div class="content-body" v-html="content.contentText"></div>
          </template>
          <el-empty v-else-if="!loading" description="未找到相关内容" />
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'ExamPlanDetail',
  data() {
    return {
      loading: false,
      content: null
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      const planData = this.$route.params.planData
      if (planData) {
        this.content = planData
      }
    }
  }
}
</script>

<style scoped lang="scss">
.page-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f7fa;
}

.main-content {
  flex: 1;
  padding-top: 20px;
}

.detail-card {
  background: #fff;
  border-radius: 8px;
  padding: 40px;
  margin-top: 20px;
  min-height: 500px;
}

.title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  text-align: center;
  margin-bottom: 20px;
}

.meta {
  text-align: center;
  color: #999;
  font-size: 14px;
  margin-bottom: 40px;
  padding-bottom: 20px;
  border-bottom: 1px solid #eee;
  
  span {
    margin: 0 10px;
  }
}

.content-body {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
  
  ::v-deep img {
    max-width: 100%;
    height: auto;
    display: block;
    margin: 20px auto;
  }
  
  ::v-deep p {
    margin-bottom: 16px;
  }
}
</style>
